
// Just a stub for apps and Crud to fill in

const ActionMan = {
};

export default ActionMan;
